import { render, staticRenderFns } from "./Upfront.vue?vue&type=template&id=6589c3c5&"
import script from "./Upfront.vue?vue&type=script&lang=js&"
export * from "./Upfront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6589c3c5')) {
      api.createRecord('6589c3c5', component.options)
    } else {
      api.reload('6589c3c5', component.options)
    }
    module.hot.accept("./Upfront.vue?vue&type=template&id=6589c3c5&", function () {
      api.rerender('6589c3c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/Tabs/Upfront.vue"
export default component.exports